import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FileSaverService } from '../common/file/file-saver.service';
import { AbstractCsvExportService } from '../common/file/abstract-csv-export.service';
import { FileSaverUsecase } from '../../domain/model/file-saver-usecase.enum';


@Injectable({
    providedIn: 'root',
})
export class NetzbetreiberExportService extends AbstractCsvExportService {
    protected http: HttpClient;
    protected fileSaverService: FileSaverService;

    constructor() {
        const http = inject(HttpClient);
        const fileSaverService = inject(FileSaverService);

        super(http, fileSaverService);

        this.http = http;
        this.fileSaverService = fileSaverService;
    }

    public exportNetzbetreiber() {
        this.exportCsv('/netzbetreiber/netzbetreiber.csv', FileSaverUsecase.CSV_EXPORT_NETZBETREIBER);
    }
}
